var _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiscSuitcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "470.77,380,256,504,41.23,380,41.23,132,256,8,470.77,132",
    fill: "#4a4a4a",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 95c-3.583 0-7.736 1.925-9.977 4.613-2.24 2.69-2.99 5.447-3.4 7.907-.82 4.92-.247 9.48.5 13.96.316 1.897.698 3.748 1.096 5.52h18.534c-.67-2.54-1.387-5.542-1.877-8.48-.35-2.093-.483-3.963-.53-5.52h87.305c-.046 1.557-.18 3.427-.53 5.52-.49 2.938-1.205 5.94-1.876 8.48h18.535c.4-1.772.78-3.623 1.097-5.52.747-4.48 1.32-9.04.5-13.96-.41-2.46-1.16-5.218-3.4-7.907C311.737 96.925 307.583 95 304 95h-96zm-105 16v18h50v-18h-50zm256 0v18h50v-18h-50zM96 145c-5 0-11.05 2.777-15.637 7.363C75.777 156.95 73 163 73 168v208c0 5 2.777 11.05 7.363 15.637C84.95 396.223 91 399 96 399h23V145H96zm41 0v254h238V145H137zm256 0v254h23c5 0 11.05-2.777 15.637-7.363C436.223 387.05 439 381 439 376V168c0-5-2.777-11.05-7.363-15.637C427.05 147.777 421 145 416 145h-23z",
    fill: "#fff",
    fillOpacity: 1,
    stroke: "#000000",
    strokeOpacity: 1,
    strokeWidth: 8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscSuitcase);
export default __webpack_public_path__ + "static/media/Misc_suitcase.89e392bd8c64f4ba203ac33e5f9d55c3.svg";
export { ForwardRef as ReactComponent };